import api from './api';

export const ticketService = {
  list: (params) => api.get('/tickets', { params }),
  get: (id) => api.get(`/tickets/${id}`),
  create: (data) => api.post('/tickets', data),
  update: (id, data) => api.put(`/tickets/${id}`, data),
  updateStatus: (id, status, comment) => api.patch(`/tickets/${id}/status`, { status, comment }),
  delete: (id) => api.delete(`/tickets/${id}`),
  getComments: (id) => api.get(`/tickets/${id}/comments`),
  addComment: (id, data) => api.post(`/tickets/${id}/comments`, data),
  getActivity: (id) => api.get(`/tickets/${id}/activity`),
  exportCsv: (params) => api.get('/tickets/export/csv', { params, responseType: 'blob' }),
};
